module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("basbr"))).then(() => parcelRequire('d0iPb'));